module.exports = __webpack_public_path__ + "static/img/4.61b9bed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/avatar/4.jpg
// module id = Snxm
// module chunks = 1 2